function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "child-unfilled",
  transform: "translate(2.5 2.5)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_89",
  "data-name": "Group 89"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_30",
  "data-name": "Group 30"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_5",
  "data-name": "Ellipse 5",
  cx: 22.5,
  cy: 22.5,
  r: 22.5,
  transform: "translate(15.001)",
  fill: "none",
  stroke: "#EE5511",
  strokeWidth: 5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_31",
  "data-name": "Path 31",
  d: "M886.732,1198.331h62.412a6.3,6.3,0,0,0,6.295-6.3v-28.392a32.813,32.813,0,0,0-32.816-32.812h-9.374a32.812,32.812,0,0,0-32.812,32.813v28.392A6.3,6.3,0,0,0,886.732,1198.331Z",
  transform: "translate(-880.437 -1078.331)",
  fill: "none",
  stroke: "#EE5511",
  strokeWidth: 5
}))));

function SvgChildUnfilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80.002,
    height: 125,
    viewBox: "0 0 80.002 125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChildUnfilled);
export default __webpack_public_path__ + "static/media/child-unfilled.d11a6728.svg";
export { ForwardRef as ReactComponent };